import type { CategoryMeta, TemplateCategory } from "./types";

/**
 * Metadados das categorias de templates
 */
export const TEMPLATE_CATEGORIES: Record<TemplateCategory, CategoryMeta> = {
  "customer-service": {
    id: "customer-service",
    nameKey: "agents:templates.categories.customer_service",
    descriptionKey: "agents:templates.categories.customer_service_description",
    icon: "lucide:headset",
    color: "blue",
  },
  sales: {
    id: "sales",
    nameKey: "agents:templates.categories.sales",
    descriptionKey: "agents:templates.categories.sales_description",
    icon: "lucide:trending-up",
    color: "green",
  },
  internal: {
    id: "internal",
    nameKey: "agents:templates.categories.internal",
    descriptionKey: "agents:templates.categories.internal_description",
    icon: "lucide:building-2",
    color: "purple",
  },
  healthcare: {
    id: "healthcare",
    nameKey: "agents:templates.categories.healthcare",
    descriptionKey: "agents:templates.categories.healthcare_description",
    icon: "lucide:heart-pulse",
    color: "red",
  },
  financial: {
    id: "financial",
    nameKey: "agents:templates.categories.financial",
    descriptionKey: "agents:templates.categories.financial_description",
    icon: "lucide:landmark",
    color: "amber",
  },
  utilities: {
    id: "utilities",
    nameKey: "agents:templates.categories.utilities",
    descriptionKey: "agents:templates.categories.utilities_description",
    icon: "lucide:zap",
    color: "orange",
  },
};

/**
 * Ordem de exibição das categorias
 */
export const CATEGORY_ORDER: TemplateCategory[] = [
  "customer-service",
  "sales",
  "internal",
  "healthcare",
  "financial",
  "utilities",
];
